"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pt_BR = _interopRequireDefault(require("../../date-picker/locale/pt_BR"));
var _default = exports.default = _pt_BR.default;